export default "__VITE_ASSET__B027XPiY__"